module.exports = __webpack_public_path__ + "static/media/1022824.ef2b1a6d.jpg";